import { SolutionType } from '../types';

export const Teams = {
  appId: '6d45a192-7d23-425a-b832-9281747d209e',
} as const;

export const Buddi = {
  userSync: 'DIRBACUSERSYNCV1',
  connectPortal: 'ConnectPortalUrl',
  projectWise365: 'ProjectWise365.Url',
} as const;

export const GprIds = {
  projectWiseWeb: 3060,
} as const;

export const SolutionTypes = {
  projectWise365: 'ProjectWise365' as SolutionType,
} as const;

export const ServiceRegistry = {
  projectWiseWebConnectionsId: '37cee1e4-6e3d-4f9b-bcdc-f10e66d56104',
  deliverablesManagementId: '47ff61e7-b177-4ad0-8b0e-96a04217768b',
  issueResolutionId: 'e072cffc-1baa-449f-84ad-3633b8f113fd',
  projectInsightsId: 'f035691c-0120-4d55-ba95-50c99fa4d315',
  formsId: '43f8f0b8-2989-4072-bb70-2c05451229f7',
  designReviewId: '9be30ee5-9703-4330-bb96-abad29e93a16',
  shareServiceId: '7af6119e-900b-415c-9a03-b617c9d7d239',
  projectWise365Id: 'c2b90524-0f33-4f86-b4a1-fadfbbb05c0b',
} as const;
